import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
declare var $ :any;

@Component({
  selector: 'app-pasajeros',
  templateUrl: './pasajeros.component.html',
  styleUrls: ['./pasajeros.component.css']
})
export class PasajerosComponent implements OnInit {
  @Input() contadorPasajerosModal;
  @Input() pasajerosArray;
  error = 0;

  @Output() addPasajeros = new EventEmitter();
  constructor() { }

  ngOnInit() {
    // $('#modalPasajeros').modal({backdrop: 'static'})
  }

  masMenosPasajeros(masMenos) {

    if (masMenos == '-') {
      if (this.contadorPasajerosModal > 1) {
        --this.contadorPasajerosModal;
        this.pasajerosArray = this.pasajerosArray.slice(0, -1)
      }
    } else {
      this.contadorPasajerosModal = this.contadorPasajerosModal + 1;

      this.pasajerosArray.push({
        Edad: "",
        Gender: -1,
        Posicion: this.contadorPasajerosModal
      })
    }
    return;
  }
  save(){
    this.addPasajeros.emit(this.pasajerosArray);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/general/modals/pasajeros/pasajeros.component.ts